import "@/App.css";
import React from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { I18nProvider } from "./i18n/I18nContext";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import Auth from "./pages/Auth";
import Onboarding from "./pages/Onboarding";
import Verify from "./pages/Verify";
import ResetPassword from "./pages/ResetPassword";
import Search from "./pages/Search";
import ListingDetail from "./pages/ListingDetail";
import Sell from "./pages/Sell";
import Messages from "./pages/Messages";
import Profile from "./pages/Profile";
import UserProfile from "./pages/UserProfile";
import Dashboard from "./pages/Dashboard";
import Favorites from "./pages/Favorites";
import Admin from "./pages/Admin";
import Support from "./pages/Support";
import NotificationsCenter from "./pages/NotificationsCenter";
import PaymentResult from "./pages/PaymentResult";
import Servicios from "./pages/Servicios";
import Plans from "./pages/Plans";
import PaypalReturn from "./pages/PaypalReturn";
import PaymentsGuide from "./pages/PaymentsGuide";
import SitePage from "./pages/SitePage";
import { SITE_PAGES } from "./lib/sitePages";

function OnboardingGate({ children }) {
  const { user } = useAuth();
  const loc = useLocation();
  if (user && user.onboarded === false && loc.pathname !== "/onboarding") {
    return <Navigate to="/onboarding" replace />;
  }
  return children;
}

function App() {
  return (
    <div className="App">
      <I18nProvider>
        <AuthProvider>
          <BrowserRouter>
            <Toaster position="top-center" richColors />
            <OnboardingGate>
              <Routes>
                <Route path="/onboarding" element={<Onboarding />} />
                <Route path="/verify" element={<Verify />} />
                <Route path="/reset-password" element={<ResetPassword />} />
                <Route path="/auth" element={<Auth />} />
                <Route element={<Layout />}>
                  <Route path="/" element={<Home />} />
                  <Route path="/search" element={<Search />} />
                  <Route path="/servicios" element={<Servicios />} />
                  <Route path="/planes" element={<Plans />} />
                  <Route path="/paypal/return" element={<PaypalReturn />} />
                  <Route path="/listing/:id" element={<ListingDetail />} />
                  <Route path="/sell" element={<Sell />} />
                  <Route path="/messages" element={<Messages />} />
                  <Route path="/profile" element={<Profile />} />
                  <Route path="/como-cobrar" element={<PaymentsGuide />} />
                  {SITE_PAGES.map((p) => (
                    <Route key={p.slug} path={p.path} element={<SitePage slug={p.slug} />} />
                  ))}
                  <Route path="/user/:id" element={<UserProfile />} />
                  <Route path="/dashboard" element={<Dashboard />} />
                  <Route path="/support" element={<Support />} />
                  <Route path="/notifications" element={<NotificationsCenter />} />
                <Route path="/payment/success" element={<PaymentResult />} />
                <Route path="/payment/cancel" element={<PaymentResult />} />
                  <Route path="/favorites" element={<Favorites />} />
                  <Route path="/admin" element={<Admin />} />
                  <Route path="*" element={<Navigate to="/" replace />} />
                </Route>
              </Routes>
            </OnboardingGate>
          </BrowserRouter>
        </AuthProvider>
      </I18nProvider>
    </div>
  );
}

export default App;
